import { jsx as _jsx } from "react/jsx-runtime";
import { Box } from '@coolblue-development/freddy';
export const MobileAdContainerBox = ({ mobileAspectRatio, children, }) => {
    return (_jsx(Box, { sx: {
            position: 'relative',
            minWidth: '100vw',
            overflow: 'hidden',
            scrollSnapAlign: 'start',
            aspectRatio: mobileAspectRatio,
            img: {
                width: '100%',
                height: 'auto',
            },
        }, children: children }));
};
//# sourceMappingURL=MobileAdContainerBox.js.map